import script from "./AssessmentDisasters.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentDisasters.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentDisasters.vue?vue&type=style&index=0&id=48c6be52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c6be52"]])

export default __exports__